import { render, staticRenderFns } from "./TariffFiling.vue?vue&type=template&id=0b478636&scoped=true&"
import script from "./TariffFiling.vue?vue&type=script&lang=js&"
export * from "./TariffFiling.vue?vue&type=script&lang=js&"
import style0 from "./TariffFiling.vue?vue&type=style&index=0&id=0b478636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b478636",
  null
  
)

export default component.exports